import { ReactElement } from 'react'
import PersonOutlineIcon from '@mui/icons-material/PersonOutline'
import { IconButton, Tooltip, Typography } from '@mui/material'
import type { GridRenderCellParams } from '@mui/x-data-grid-premium'
import { Box } from '@ui/structure'

/**
 * The Primärbearbeiter display cell: a dash when unassigned, or the resolved
 * name with a person button for an admin of the project's own organisation.
 * Clicking either opens the DataGrid's own edit mode for this cell -- see
 * `PrimaryEditorEditCell`, wired as this column's `renderEditCell`.
 */
const PrimaryEditorCell = (
  params: GridRenderCellParams<{ project: ProjectData }>,
): ReactElement => {
  const label = params.row.project.primary_editor_name || '—'

  if (!params.isEditable) {
    return <Typography variant="body2">{label}</Typography>
  }

  const startEditing = () => params.api.startCellEditMode({ id: params.id, field: params.field })

  return (
    // the whole cell opens the picker, not just the button
    <Box
      display="flex"
      alignItems="center"
      gap={0.5}
      width="100%"
      height="100%"
      onClick={startEditing}
      sx={{ cursor: 'pointer' }}
      data-cy="project-primary-editor-cell"
    >
      <Typography variant="body2">{label}</Typography>
      <Tooltip title="Bearbeiter ändern" enterDelay={1000}>
        <IconButton size="small" onClick={startEditing} data-cy="btn-reassign-primary-editor">
          <PersonOutlineIcon fontSize="inherit" />
        </IconButton>
      </Tooltip>
    </Box>
  )
}

export default PrimaryEditorCell
